import api from '@/api'
import { param } from 'jquery'

export default {
    getMyPeoples(request: graph.PeopleRequest): Promise<graph.PeopleResponse> {
        return api.post({ 
            url: '/Graph/User/api/GetMyPeoples',
            data: request
         })
    },

    getMyTeams(upn: string): Promise<graph.TeamsGroup[]> {
        return api.get({ 
            url: '/Graph/Teams/api/GetTeams',
            params: {
                upn: upn
            }
        })
    },

    getRecentFiles(): Promise<graph.DriveItem[]> {
        return api.get({ url: '/Graph/Drive/api/GetRecentFiles' })
    },

    getDriveItems(request: graph.DriveItemsRequet): Promise<graph.DriveItem[]> {
        return api.post({
            url: '/Graph/Drive/api/GetDriveItems',
            data: request
        })
    },

    getUnreadMail(): Promise<graph.MailResponse> {
        return api.get({
            url: '/Graph/Outlook/api/getUnreadMail'
        })
    },

    getRecentMail(): Promise<graph.MailResponse> {
        return api.get({
            url: '/Graph/Outlook/api/getRecentMail'
        })
    },

    getCalendarEvents(start: string, end: string): Promise<graph.CalendarItem[]> {
		return api.get({
			url:   `/Graph/Outlook/api/getSchedules?start=${start}&end=${end}`
		})
	}
}